<template>
<div class="note">
  <div class="tape"></div>
  <div class="postit">
    <p class="header">Emergency Contacts</p>
    <p>Boris <i>224 277-1846</i></p>
    <p>Geppetto <i>856 982-2284</i></p>
    <p>Smelt <i>617 595-6623</i></p>
  </div>
</div>
</template>

<script>
export default {
  name: 'note'
}
</script>

<style lang="scss" scoped>
.note {
  position: absolute;
  top: 38%;
  left: 63%;
  transform: rotateZ(-6deg);
}

.tape {
  width: 35px;
  height: 80px;
  background: transparentize(grey, .6);
  border: 1px solid transparentize(darkgrey, .9);
  position: absolute;
  z-index: 1;
  left: 48%;
  top: -3%;
  transform: rotateZ(23deg);
}

.postit {
  background: linear-gradient(135deg, #ffff88 81%,#ffff88 82%,#ffff88 82%,#ffffc6 100%); /* W3C */
  line-height: 1;
  text-align:center;
  width: 275px;
  margin: 25px;
  min-height: 180px;
  max-height: 180px;
  padding-top: 75px;
  padding-left: 27px;
  position: relative;
  border: 1px solid #E8E8E8;
  font-family: 'Kalam', cursive;
  font-size: 22px;
  border-bottom-right-radius: 60px 5px;
  display:inline-block;
  text-align: left;

  p {
    margin: 0;

    &.header {
      margin-bottom: 15px;
    }

    + p {
      margin-top: 10px;
    }
  }

  &::before {
    content: '';
    display: block;
    transform: translateY(-77px);
    border-top: 1px solid lightgrey;
  }

  &::after {
    content: "";
    position:absolute;
    z-index:-1;
    right:-0px;
    bottom:20px;
    width:200px;
    height: 25px;
    background: rgba(0, 0, 0, 0.2);
    box-shadow:2px 15px 5px rgba(0, 0, 0, 0.40);
    transform: matrix(-1, -0.1, 0, 1, 0, 0);
  }
}
</style>
